import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';
import TableCell from 'components/TableCell';

import { PagesListRow_page$key } from '__generated__/PagesListRow_page.graphql';

type Props = SortableEntityTableRowProps & {
  page: PagesListRow_page$key;
};

const PagesListRow: FC<Props> = ({ page, ...props }) => {
  const pageData = useFragment(
    graphql`
      fragment PagesListRow_page on Page {
        id
        name

        ...SortableEntityTableRow_entity
      }
    `,
    page
  );

  const { id, name } = pageData;

  return (
    <SortableEntityTableRow entity={pageData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>
    </SortableEntityTableRow>
  );
};

export default PagesListRow;
